import { useCallback, useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

export const useActionPlanSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchData = useMemo(() => {
    const from = searchParams.get('from') || '';
    const to = searchParams.get('to') || '';
    const departmentId = searchParams.get('departmentId') || null;
    const employeeId = searchParams.get('employeeId') || null;
    const actionId = searchParams.get('actionId') || null;
    const period = searchParams.get('period') || 'DAILY';
    const tabMode = searchParams.get('tabMode') || 'EMPLOYEE';

    return {
      from,
      to,
      departmentId,
      employeeId,
      actionId,
      period,
      tabMode,
    };
  }, [searchParams]);

  const setSearchData = useCallback(
    (updates) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);

        Object.entries(updates).forEach(([key, value]) => {
          if (value === null || value === '' || value === undefined) {
            newParams.delete(key);
          } else {
            newParams.set(key, String(value));
          }
        });

        return newParams;
      });
    },
    [setSearchParams]
  );

  const resetSearchData = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  return { searchData, setSearchData, resetSearchData };
};
